/**
 * Created by ChrisMuto on 7/18/17.
 */

/*
 Global Events
 */
export const DID_NAVIGATE_TO_CREATE_PROJECT =
    "Configure Project: navigated to create new project";
export const DID_NAVIGATE_TO_EDIT_PROJECT =
    "Configure Project: navigated to edit project";

export const DID_CHANGE_NAVIGATION_STEP_IN_SIDEBAR =
    "Configure Project: changed step with sidebar click";
export const DID_CHANGE_NAVIGATION_STEP_IN_CONTENT =
    "Configure Project: changed step with CTA within page";

export const DID_CLICK_INACTIVE_NAVIGATION_STEP =
    "Configure Project: clicked inactive step";
export const DID_CLICK_SIDEBAR_SAVE_AND_EXIT =
    "Configure Project: clicked save and exit in sidebar";

/*
 Project Definition
 */

export const DID_NAVIGATE_TO_PROJECT_DEFINITION =
    "Project Definition: navigated to project definition";

export const DID_SELECT_PROJECT_DEVICE =
    "Project Definition: selected device for project";

export const DID_ATTEMPT_PROJECT_CREATION =
    "Project Definition: attempted to create project";
export const DID_CREATE_PROJECT_SUCCESSFULLY =
    "Project Definition: created project successfully";

export const DID_ATTEMPT_PROJECT_EDIT =
    "Project Definition: attempted to save project edits";
export const DID_EDIT_PROJECT_SUCCESSFULLY =
    "Project Definition: edited project successfully";

export const DID_RECEIVE_INVALID_PROJECT_NAME_WARNING =
    "Project Definition: received invalid project name error";

export const DID_RECEIVE_PROJECT_DEFINITION_ERROR =
    "Project Definition: received an error";

/*
 Select Pages
 */

export const DID_NAVIGATE_TO_PAGE_SELECTION =
    "Page Selection: navigated to select pages";

export const DID_OPEN_FILE_BROWSER = "Page Selection: opened file browser";
export const DID_CLOSE_FILE_BROWSER =
    "Page Selection: cancelled out of file browser";
export const DID_DRAG_OVER =
    "Page Selection: dragged files over the drag and drop area";
export const DID_DRAG_OUT =
    "Page Selection: dragged files out of the drag and drop area";
export const DID_RECEIVE_VALIDATION_ERROR =
    "Page Selection: received invalid files to upload error";
export const DID_SELECT_FILES_FOR_UPLOAD =
    "Page Selection: selected files to upload";

export const DID_ATTEMPT_MARK_BASELINE =
    "Page Selection: attempted to mark a page as baseline";
export const DID_ATTEMPT_UNMARK_BASELINE =
    "Page Selection: attempted to unmark a page as baseline";
export const DID_ATTEMPT_MARK_COMPETITOR =
    "Page Selection: attempted to mark a page as a competitor";
export const DID_ATTEMPT_UNMARK_COMPETITOR =
    "Page Selection: attempted to unmark a page as a competitor";
export const DID_ATTEMPT_EDIT_PAGE_NAME =
    "Page Selection: attempted to rename page ";

export const DID_ATTEMPT_PAGE_CREATION =
    "Page Selection: attempted to create page";
export const DID_CREATE_PAGE_SUCCESSFULLY = "Page Selection: created a page";

export const DID_REMOVE_UPLOAD_ERROR_CARD =
    "Page Selection: removed upload error card";

export const DID_ATTEMPT_PAGE_REMOVAL =
    "Page Selection: attempted to remove page";
export const DID_REMOVE_PAGE_SUCCESSFULLY = "Page Selection: removed a page";
export const DID_EDIT_PAGE_SUCCESSFULLY = "Page Selection: updated a page";

export const DID_RECEIVE_SELECT_PAGES_ERROR =
    "Page Selection: received an error";
export const DID_UPLOAD_REJECTED_FILE =
    "Page Selection: uploaded rejected file";
export const DID_UPLOAD_FILE_WITH_INVALID_TYPE =
    "Page Selection: uploaded file with invalid type";
export const DID_UPLOAD_FILE_WITH_INVALID_SIZE =
    "Page Selection: uploaded file with invalid size";

/*
 Pick CTAs
 */

export const DID_NAVIGATE_TO_PICK_CTAS = "Pick CTAs: navigated to pick ctas";

export const DID_ATTEMPT_CTA_CREATION =
    "Pick CTAs: attempted to add a cta to a page";
export const DID_CREATE_CTA_SUCCESSFULLY = "Pick CTAs: added a cta to a page";

export const DID_ATTEMPT_CTA_REMOVAL =
    "Pick CTAs: attempted to remove a cta from the page";
export const DID_REMOVE_CTA_SUCCESSFULLY =
    "Pick CTAs: removed a cta from the page";

export const DID_SWITCH_PAGES_WITH_KEYBOARD =
    "Pick CTAs: changed active page with keyboard";
export const DID_SWITCH_PAGES_WITH_ARROW_CLICK =
    "Pick CTAs: changed active page by clicking arrows on page";
export const DID_SWITCH_PAGES_WITH_THUMBNAIL_CLICK =
    "Pick CTAs: changed active page by clicking thumbnail";

export const DID_RECEIVE_PICK_CTA_ERROR = "Pick CTAs: received an error";

/*
 Select Audience
 */

export const DID_NAVIGATE_TO_SELECT_AUDIENCE =
    "Select Audience: navigated to select audience";

export const DID_OPEN_ADD_AUDIENCE_MENU =
    "Select Audience: clicked the card to add an audience";

export const DID_ATTEMPT_AUDIENCE_ATTACH =
    "Select Audience: attempted to attach an audience";
export const DID_ATTACH_AUDIENCE_SUCCESSFULLY =
    "Select Audience: attached an audience";

export const DID_ATTEMPT_AUDIENCE_DETACH =
    "Select Audience: attempted to detach an audience";
export const DID_DETACH_AUDIENCE_SUCCESSFULLY =
    "Select Audience: detached an audience";

export const DID_ATTEMPT_SEGMENT_EDIT =
    "Select Audience: attempted to edit segment value";
export const DID_EDIT_SEGMENT_SUCCESSFULLY =
    "Select Audience: edited segment value";

export const DID_RECEIVE_AUDIENCE_VALIDATION_ERROR =
    "Select Audience: received segment sum validation error";

export const DID_RECEIVE_SELECT_AUDIENCE_ERROR =
    "Select Audience: received an error in select audience";

/*
 Launch Page
 */

export const DID_NAVIGATE_TO_PROJECT_REVIEW =
    "Project Review: navigated to project review";

export const DID_CLICK_RESOLVE_CONFIGURATION_ISSUE =
    "Project Review: clicked button to resolve project issue";
export const DID_CLICK_VIEW_CONFIGURATION_SECTION =
    "Project Review: clicked button to view section configuration";
export const DID_CLICK_DISABLED_RESOLVE_BUTTON =
    "Project Review: clicked disabled button";
export const DID_CLICK_REVIEW_SAVE_AND_EXIT =
    "Project Review: clicked save and exit";

export const DID_ATTEMPT_PROJECT_LAUNCH =
    "Project Review: attempted to launch project";
export const DID_SUCCESSFULLY_LAUNCH_PROJECT =
    "Project Review: launched project";

export const DID_RECEIVE_PROJECT_REVIEW_ERROR =
    "Project Review: received an error";



// WEBPACK FOOTER //
// ./src/modules/tracker/event-names/configure-wevo-events.js